<template>
  <div class="footer">
    <div
      class="button"
      @click="selectMenu(24)"
      :class="index == 24 ? 'button-active' : ''"
    >
      <img src="@/assets/images/companyinfo.png" alt="" v-if="index != 24" />
      <img
        src="@/assets/images/companyinfo-active.png"
        alt=""
        v-if="index == 24"
      />
      <div>生产线</div>
    </div>
    <div
      class="button"
      @click="selectMenu(25)"
      :class="index == 25 ? 'button-active' : ''"
    >
      <img src="@/assets/images/companyinfo.png" alt="" v-if="index != 25" />
      <img
        src="@/assets/images/companyinfo-active.png"
        alt=""
        v-if="index == 25"
      />
      <div>库存区</div>
    </div>
    <div
      class="button"
      @click="selectMenu(26)"
      :class="index == 26 ? 'button-active' : ''"
    >
      <img src="@/assets/images/companyinfo.png" alt="" v-if="index != 26" />
      <img
        src="@/assets/images/companyinfo-active.png"
        alt=""
        v-if="index == 26"
      />
      <div>入库信息</div>
    </div>
    <div
      class="button"
      @click="selectMenu(27)"
      :class="index == 27 ? 'button-active' : ''"
    >
      <img src="@/assets/images/companyinfo.png" alt="" v-if="index != 27" />
      <img
        src="@/assets/images/companyinfo-active.png"
        alt=""
        v-if="index == 27"
      />
      <div>出库信息</div>
    </div>
    <div
      class="button"
      @click="selectMenu(28)"
      :class="index == 28 ? 'button-active' : ''"
    >
      <img src="@/assets/images/companyinfo.png" alt="" v-if="index != 28" />
      <img
        src="@/assets/images/companyinfo-active.png"
        alt=""
        v-if="index == 28"
      />
      <div>视频监控</div>
    </div>
  </div>
</template>
  
  <script>
export default {
  props: ["index"],
  data() {
    return {
      showPopover: false,
      nowTime: "",
      type: "index",
    };
  },

  methods: {
    selectMenu(index) {
      this.showPopover = false;
      this.$emit("selectMenu", index);
    },
  },
};
</script>
<style>
.button-footer .button {
  display: flex;
  align-items: center;
  justify-content: center;
  background: url("~@/assets/botton.png") no-repeat center;
  background-size: 100% 100%;
  width: 200px;
  padding: 10px 0;
  color: #fff;

  cursor: pointer;
}
.button-footer .button img {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}
.el-popover {
  background: unset;
  padding: unset;
  border: unset;
  border-radius: unset;
}
</style>
